webpackJsonp([17],{

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DateIntervalPicker.vue



/* harmony default export */ var DateIntervalPicker = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [null, null];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      popup: false,
      dates: this.value.map(function (value, i) {
        return {
          value: value,
          title: _this.$t('dateintervalpicker.dates.' + i),
          menu: false
        };
      })
    };
  },

  computed: {
    tr: function tr() {
      return {
        'night': 'jour',
        'nights': 'jours',
        'check-in': 'Du',
        'check-out': 'au',
        'day-names': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        'month-names': ['Jan', 'Fev', 'Mars', 'Avril', 'Mai', 'Juin', 'Juill', 'Août', 'Sept', 'Oct', 'Nov', 'Déc']
      };
    }
  },
  methods: {
    emit: function emit() {
      this.popup = false;
      this.$emit('input', this.dates.map(function (x) {
        return x.value;
      }));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.dates = this.dates.map(function (date, i) {
      return extends_default()({}, date, {
        menu: date.value && !(_this2.dates[i + 1] || {}).value
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4413915a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateIntervalPicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{model:{value:(_vm.popup),callback:function ($$v) {_vm.popup=$$v},expression:"popup"}},[_c('v-btn',{staticClass:"fixed",attrs:{"slot":"activator","floating":""},slot:"activator"},[_c('v-icon',[_vm._v("today")])],1),_vm._v(" "),_c('v-card',[_c('v-expansion-panel',_vm._l((_vm.dates),function(date,i){return _c('v-expansion-panel-content',{key:i,attrs:{"value":date.menu && _vm.popup}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(date.title)+" "+_vm._s(date.value))]),_vm._v(" "),_c('v-card',[_c('v-date-picker',{staticClass:"elevation-0",attrs:{"no-title":""},model:{value:(date.value),callback:function ($$v) {_vm.$set(date, "value", $$v)},expression:"date.value"}})],1)],1)}),1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"block":"","primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.emit.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"light":""}},[_vm._v("check")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_DateIntervalPicker = (esExports);
// CONCATENATED MODULE: ./src/components/DateIntervalPicker.vue
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4413915a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  DateIntervalPicker,
  components_DateIntervalPicker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_DateIntervalPicker = (Component.exports);

// CONCATENATED MODULE: ./src/mixins/withInterval.js



/* harmony default export */ var withInterval = __webpack_exports__["a"] = ({
  components: {
    DateIntervalPicker: src_components_DateIntervalPicker
  },
  data: function data() {
    return {
      interval: [this.$route.query.from || null, this.$route.query.to || null]
    };
  },

  computed: {
    params: function params() {
      return this.$route.query;
    }
  },
  watch: {
    interval: function interval() {
      this.$router.replace(extends_default()({}, this.$route, {
        query: extends_default()({}, this.$route.query, {
          from: this.interval[0],
          to: this.interval[1]
        })
      }));
    }
  }
});

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("18c27bb6", content, true);

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".fixed[data-v-4413915a]{z-index:1}.picker[data-v-4413915a]{max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/DateIntervalPicker.vue"],"names":[],"mappings":"AACA,wBAA0B,SAAW,CACpC,AACD,yBAA2B,cAAgB,CAC1C","file":"DateIntervalPicker.vue","sourcesContent":["\n.fixed[data-v-4413915a] { z-index: 1;\n}\n.picker[data-v-4413915a] { max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/api/metrics.js
var metrics = __webpack_require__(365);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// EXTERNAL MODULE: ./src/mixins/withInterval.js + 3 modules
var withInterval = __webpack_require__(752);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Accounting.vue









/* harmony default export */ var Accounting = ({
  components: {
    Minute: formatters["c" /* Minute */],
    Price: formatters["d" /* Price */]
  },
  mixins: [withInterval["a" /* default */]],
  data: function data() {
    return {
      experts: [],
      loading: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platform: 'skiliko/session/currentPlatform'
  }), {
    headers: function headers() {
      return [{ text: this.$t('pages.statistics.expert'), left: true, sortable: false }, { text: this.$t('pages.statistics.call'), left: false, sortable: false }, { text: this.$t('pages.statistics.email'), left: false, sortable: false }, { text: this.$t('pages.statistics.service'), left: false, sortable: false }, { text: this.$t('pages.statistics.product'), left: false, sortable: false }, { text: this.$t('pages.statistics.chat'), left: false, sortable: false }, { text: this.$t('pages.statistics.total'), left: false, sortable: false }];
    }
  }),
  methods: {
    reloadStats: function reloadStats() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return metrics["a" /* default */].generalExpertStats({ params: _this.params });

              case 3:
                _this.experts = _context.sent.data;

                _this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    phoneGains: function phoneGains(stat) {
      return stat.call_sum / 60 * this.platform.settings.fix_minute_price;
    },
    gain: function gain(service, expert, stat) {
      var repartition = [(expert.repartition || {})[service], (this.platform.settings.default_expert_repartition || {})[service]].filter(function (x) {
        return x !== undefined;
      })[0] || 0;
      return stat[service + '_sum'] * repartition / 100;
    },
    total: function total(expert, stat) {
      var _this2 = this;

      return this.phoneGains(stat) + ['mail', 'service', 'product', 'availability'].reduce(function (prev, x) {
        return prev + _this2.gain(x, expert, stat);
      }, 0);
    }
  },
  watch: {
    params: function params() {
      this.reloadStats();
    }
  },
  mounted: function mounted() {
    this.reloadStats();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0470195c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Accounting.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('pages.accounting.title')))]),_vm._v(" "),_c('DateIntervalPicker',{staticClass:"mb-3",model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}}),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.experts,"custom-sort":function (a) { return a; },"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('router-link',{attrs:{"to":{ name: 'Expert', params: { id: props.item.expert.id, tab: 'profile' } }}},[_vm._v("\n            "+_vm._s(props.item.expert.nickname)+"\n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('minute',{attrs:{"value":props.item.statistics.call_sum}}),_vm._v(" "),(props.item.statistics.call_sum)?_c('span',[_vm._v("("),_c('price',{attrs:{"value":_vm.phoneGains(props.item.statistics)}}),_vm._v(")")],1):_c('span',[_vm._v("-")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":_vm.gain('mail', props.item.expert, props.item.statistics)}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":_vm.gain('service', props.item.expert, props.item.statistics)}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":_vm.gain('product', props.item.expert, props.item.statistics)}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":_vm.gain('availability', props.item.expert, props.item.statistics)}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('strong',[_c('price',{attrs:{"value":_vm.total(props.item.expert, props.item.statistics)}})],1)])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Accounting = (esExports);
// CONCATENATED MODULE: ./src/pages/Accounting.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Accounting,
  pages_Accounting,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Accounting = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/17.2bfe03e8ed9e23f26871.js